import React from "react";
import ContentLoader from "react-content-loader";

const MyLoader = () => (
  <ContentLoader
    speed={2}
    width="100%" // Largeur à 100%
    height={160} // Hauteur définie
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
  >
    <rect x="0" y="0" rx="5" ry="5" width="100%" height="20" />
    <rect x="0" y="40" rx="5" ry="5" width="90%" height="20" />
    <rect x="0" y="80" rx="5" ry="5" width="95%" height="20" />
  </ContentLoader>
);

export default MyLoader;
